import { render, staticRenderFns } from "./HOME_MESSAGE_SEND.vue?vue&type=template&id=19193899&scoped=true"
import script from "./HOME_MESSAGE_SEND.vue?vue&type=script&lang=ts"
export * from "./HOME_MESSAGE_SEND.vue?vue&type=script&lang=ts"
import style0 from "./HOME_MESSAGE_SEND.vue?vue&type=style&index=0&id=19193899&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19193899",
  null
  
)

export default component.exports